/**
 * Get base URL for routing with fallback to '/'
 * Prevents 'undefined' from appearing in URLs
 */
export const getBaseUrl = (): string => {
  const baseUrl = import.meta.env.BASE_URL;
  // If BASE_URL is undefined, null, empty, or the string 'undefined', return '/'
  if (!baseUrl || baseUrl === 'undefined' || baseUrl.trim() === '') {
    return '/';
  }
  // Ensure it ends with '/' for proper path concatenation
  const trimmed = baseUrl.trim();
  return trimmed.endsWith('/') ? trimmed : trimmed + '/';
};

/**
 * Base URL constant for use throughout the application
 */
export const BASE_URL = getBaseUrl();

